<template>
    <div class="audit-log">
      <el-table
        :data="custEvents"
        style="width: 100%;margin-bottom: 20px;"
        :header-cell-style="{background:'#F3F2F7',color:'#5E5873'}"
        @sort-change="sortChange"
        >
        <el-table-column
          prop="id"
          label="序号"
        >
        </el-table-column>
        <el-table-column
          prop="eventContent"
          label="审核意见"
        >
        </el-table-column>
        <el-table-column
          prop="eventPerson"
          label="操作人">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="操作时间"
          sortable
        >
        </el-table-column>
      </el-table>
<!--      <div class="pagination-outer" v-if="total">-->
<!--        <span class="tatol-count">共计{{total}}条</span>-->
<!--        <vs-pagination-->
<!--          class="pagination-box"-->
<!--          :max="size"-->
<!--          :total="pageSize"-->
<!--          v-model="page"-->
<!--        ></vs-pagination>-->
<!--      </div>-->
    </div>
</template>

<script>

    export default {
        name: "auditlog",
      props: {
        custEvents: {
          type: Array,
          default(){
            return []
          }
        },
      },
    }
</script>

<style scoped>

</style>
